<ng-container>
  <div class="page-title-container rmt2">
    <div *ngIf="alertMessage !== ''" class="rmt15">
      <alert-message
        [messageText]="alertMessage"
        [icon]="'check_circle-success.svg'"
        [background]="'alert-success-light success'"
        (closeAlert)="HideMessage()"
      >
      </alert-message>
    </div>
  </div>
  <div
    *ngIf="pageDisclaimer"
    class="d-flex align-items-start setting-info-container"
  >
    <img src="./assets/icons/info_icon.svg" alt="" />
    <span>{{ pageDisclaimer }}</span>
  </div>
  <div class="row page-container page-content-container rmt10">
    <div class="base-container rpt5">
      <div class="d-flex justify-content-end">
        <button-component
          *ngFor="let button of additionalButtons"
          [buttonClass]="button.buttonClass"
          [Text]="button.Text"
          [isLeftImg]="button.isLeftImg"
          [isRightImg]="button.isRightImg"
          [isButtonDisabled]="button.isButtonDisabled"
          [buttonImage]="button.buttonImage"
          (OnClick)="button.OnClick()"
        ></button-component>
        <filter
          *ngIf="isShowFilter"
          [filterList]="globalFilters"
          [isSearchIconVisible]="true"
          (emitFilterData)="applyGlobalFilter($event)"
          [isCallClearFilter]="true"
          (clearFilter)="clearGlobalFilter()"
        ></filter>
      </div>
      <div>
        <pagination
          [paginationTitle]="paginationTitle"
          [totalPageNumber]="totalPageNumber"
          [totalRecords]="data.totalCount ?? 0"
          (emitPageConfig)="OnPageChanged($event)"
          [pageFiltered]="checkPageFiltered()"
          (emitClearFilterAction)="clearFilters(dt)"
        >
        </pagination>
      </div>

      <div
        [ngClass]="
          (data.totalCount ?? 0 > 0)
            ? 'grid-table-spacer'
            : 'grid-table-spacer mt-2'
        "
        class="grid-table-spacer"
      >
        <p-table
          #dt
          [lazy]="true"
          styleClass="p-datatable-striped"
          [value]="pageData"
          [customSort]="true"
          sortField="{{ defaultSort }}"
          [sortOrder]="defaultSortAscending ? 1 : -1"
          [scrollHeight]="'auto'"
          [globalFilterFields]="tableFilter"
          dataKey="{{ dataKey }}"
          [scrollable]="true"
          class="fw-400"
          (onLazyLoad)="CustomSortandFilter($event)"
          [expandedRowKeys]="expandedRows"
        >
          <ng-template pTemplate="header">
            <tr>
              <th [style.width]="'4%'" *ngIf="snackViewColumns.length > 0"></th>
              <th
                class="grid-column"
                [style.width]="'2%'"
                *ngIf="isAllowRowSelection"
              >
                <label class="checkbox-container fw-400">
                  <input
                    type="checkbox"
                    id="checkbox"
                    value="dataKey"
                    [ngModel]="globalSelect"
                    (change)="onSelectAllRow($event)"
                  />
                  <span class="checkmark rml7"></span>
                </label>
              </th>
              <th
                [ngStyle]="{ width: column.width ?? gridColumnWidth }"
                *ngFor="let column of tableColumns; let i = index"
                pSortableColumn="{{ column.fieldName }}"
              >
                <div>
                  <div class="d-flex justify-content-start">
                    {{ GetDisplayName(column) }}
                    <div class="align-items-start">
                      <p-sortIcon field="{{ column.fieldName }}"></p-sortIcon>
                      <p-columnFilter
                        *ngIf="column.columnType === columnType.Date"
                        type="date"
                        field="{{ column.fieldName }}"
                        display="menu"
                        [ngClass]="
                          column.selectedDateType!.id !== 0
                            ? 'calender-active ml-auto'
                            : 'ml-auto'
                        "
                        [showClearButton]="false"
                        [showMatchModes]="false"
                        [showApplyButton]="true"
                        [showAddButton]="false"
                        [showOperator]="false"
                        [placeholder]="'Enter Here'"
                        [hideOnClear]="true"
                        id="{{ column.fieldName }}"
                      >
                        <ng-template
                          pTemplate="filter"
                          let-value
                          let-filter="filterCallback"
                        >
                          <p-dropdown
                            [options]="dateObjects"
                            [(ngModel)]="column.selectedDateType"
                            optionLabel="name"
                            styleClass="calendar-icon"
                            dropdownIcon="drop-down-icon"
                            id="dateFilter"
                          ></p-dropdown>
                          <p-calendar
                            *ngIf="column.selectedDateType!.id === 5"
                            [(ngModel)]="column.dateRange"
                            selectionMode="range"
                            [readonlyInput]="true"
                            [showIcon]="true"
                            [styleClass]="'restricted-width mt-1'"
                            placeholder="Enter here"
                          ></p-calendar>
                        </ng-template>
                      </p-columnFilter>
                      <p-columnFilter
                        *ngIf="
                          column.filterOptions &&
                          column.filterOptions.length > 0
                        "
                        field="{{ column.fieldName }}"
                        display="menu"
                        class="ml-auto"
                        [showClearButton]="true"
                        [showApplyButton]="false"
                        [showAddButton]="false"
                        [showOperator]="false"
                        matchMode="equals"
                        [showMatchModes]="false"
                        [hideOnClear]="true"
                        id="{{ column.fieldName }}"
                      >
                        <ng-template
                          pTemplate="filter"
                          let-value
                          let-filter="filterCallback"
                        >
                          <p-dropdown
                            [ngModel]="value"
                            [options]="column.filterOptions"
                            (onChange)="filter($event.value)"
                            placeholder="All"
                          >
                          </p-dropdown>
                        </ng-template>
                      </p-columnFilter>
                      <p-columnFilter
                        *ngIf="
                          column.columnType === columnType.Text &&
                          !column.filterOptions
                        "
                        type="text"
                        field="{{ column.fieldName }}"
                        display="menu"
                        class="ml-auto"
                        [showClearButton]="true"
                        [showApplyButton]="true"
                        [showAddButton]="false"
                        [showOperator]="false"
                        [matchModeOptions]="matchModeOptions"
                        [matchMode]="matchModeOptions[0].value"
                        [placeholder]="'Enter Here'"
                        [hideOnClear]="true"
                        id="{{ column.fieldName }}"
                      >
                      </p-columnFilter>
                    </div>
                  </div>
                </div>
              </th>
              <th [style.width]="'4%'" *ngIf="isShowContextMenus"></th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-b
            let-i="rowIndex"
            let-expanded="expanded"
            sortMode="multiple"
          >
            <tr
              [ngClass]="[
                b.status === InactiveStatus && !expanded
                  ? 'deActivatedRow'
                  : '',
                expanded ? 'expandRow' : '',
              ]"
              gridRowHoverBg
              [id]="i + 1"
            >
              <td
                *ngIf="snackViewColumns.length > 0"
                [ngClass]="b.status === InactiveStatus ? 'deActivatedRow' : ''"
              >
                <button
                  type="button"
                  pButton
                  pRipple
                  [pRowToggler]="b"
                  class="p-button-text p-button-rounded p-button-plain"
                >
                  <img
                    [src]="
                      expanded
                        ? './assets/icons/expand-down.svg'
                        : './assets/icons/expand-right.svg'
                    "
                    alt=""
                  />
                </button>
              </td>
              <td *ngIf="isAllowRowSelection">
                <label class="checkbox-container fw-400">
                  <input
                    type="checkbox"
                    id="{{ b[dataKey] }}"
                    [value]="b[dataKey]"
                    [(ngModel)]="b.isChecked"
                    [disabled]="
                      b.isSelectable !== null &&
                      b.isSelectable !== undefined &&
                      !b.isSelectable
                    "
                    (change)="onRowSelect($event, b[dataKey])"
                  />
                  <span
                    [ngClass]="
                      expanded ? 'checkmark checkmark-white' : 'checkmark'
                    "
                  ></span>
                </label>
              </td>
              <td
                *ngFor="let gview of tableColumns"
                [ngClass]="b.status === InactiveStatus ? 'deActivatedRow' : ''"
              >
                <ng-container
                  *ngIf="
                    gview.icon &&
                    gview.icon.length > 0 &&
                    gview.iconAlignment === 'left'
                  "
                >
                  <img class="rmr10" [src]="getIconSrc(gview, b)" alt="" />
                </ng-container>
                <span
                  *ngIf="gview.callback"
                  class="tdn c-p"
                  [ngClass]="expanded ? '' : 'brandText'"
                  (click)="gview.callback(b)"
                >
                  {{
                    GetFieldValue(b, gview) !== ''
                      ? GetFieldValue(b, gview)
                      : '-'
                  }}
                </span>
                <span *ngIf="!gview.callback">
                  {{
                    GetFieldValue(b, gview) !== ''
                      ? GetFieldValue(b, gview)
                      : '-'
                  }}
                </span>
                <ng-container
                  *ngIf="
                    gview.icon &&
                    gview.icon.length > 0 &&
                    gview.iconAlignment === 'right'
                  "
                >
                  <img class="rmr10" [src]="getIconSrc(gview, b)" alt="" />
                </ng-container>
              </td>
              <td
                *ngIf="isShowContextMenus"
                [ngClass]="b.status === InactiveStatus ? 'deActivatedRow' : ''"
              >
                <ng-container *ngIf="!isReadOnly; else viewOnly">
                  <app-context-menu
                    (emitPageConfig)="OnPageChanged($event)"
                    [contextMenuItems]="b.contextMenuItems"
                    [align]="'left'"
                    [icon]="expanded ? 'more-vert-lite.svg' : 'more-vert.svg'"
                  ></app-context-menu>
                </ng-container>
                <ng-template #viewOnly>
                  <app-view-only-icon
                    [expanded]="expanded"
                    [icon]="'./assets/icons/preview.svg'"
                    [altText]="'View'"
                    [action]="b.contextMenuItems[0]?.action"
                  ></app-view-only-icon>
                </ng-template>
              </td>
            </tr>
          </ng-template>
          <ng-template
            *ngIf="snackViewColumns.length > 0"
            pTemplate="rowexpansion"
            let-b
          >
            <tr></tr>
            <tr>
              <td colspan="12" class="expandedbg">
                <div class="expended-row-container">
                  <div
                    *ngFor="let sviewColumn of GetVisibleSnackViewColumns(b)"
                    [ngStyle]="{
                      width: sviewColumn.width ?? gridColumnWidth,
                    }"
                    class="expended-col"
                  >
                    <div class="expanded-col-heading">
                      {{ GetDisplayName(sviewColumn) }}
                    </div>
                    <div class="expanded-col-data">
                      {{
                        GetFieldValue(b, sviewColumn) !== ''
                          ? GetFieldValue(b, sviewColumn)
                          : '-'
                      }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div *ngIf="data.totalCount === 0" class="no-results text-center">
        No records found
      </div>
    </div>
  </div>
</ng-container>
